var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.marunage_count > 0
    ? _c("div", { staticClass: "ui olive message" }, [
        _c("ul", { staticClass: "list" }, [
          _c("li", [
            _c("a", { attrs: { href: "/shopadmin/candidates?status=false" } }, [
              _vm._v(
                "立候補可能な宴会が" + _vm._s(_vm.marunage_count) + "件あります"
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }